import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * Returns the translation key for the given attendance state.
 *
 * @param state - The attendance state enum value.
 * @returns The i18n translation key corresponding to the state.
 */
export function getAttendanceStateTranslationKey(state: Enums<"attendanceState">): TranslationKey {
	switch (state) {
		case "pending":
			return "users.attendance_state.pending";
		case "approved":
			return "users.attendance_state.approved";
		case "rejected":
			return "users.attendance_state.rejected";
	}
}
